import axios from "../../services/Api";
import { showToast } from "../../services/functions";
import { FETCH_ERROR, FETCH_SALES_DETAIL, FETCH_SALES_ORDER_ITEM_LIST, FETCH_SALES_ORDER_PROCESSING,
     FETCH_SALES_STATUS_COUNT, FETCH_START, FETCH_SUCCESS, GENERATE_SO_NUMBER,FETCH_ESOPFORM_TABLE_DATA,
      FETCH_PASSLINK_VALIDATION_TOKEN,FETCH_ASSOCIATED_JOB, FETCH_ASSOCIATED_TRIP, FETCH_AVAILABLE_SLOTS,FETCH_SALES_ORDER_CARD_COUNT,
    VALIDATE_SALES_CONSUMPTION, FETCH_SALES_ORDER_DISPATCH_PLANS } from "../types";


export const getSalesOrderTableData = (payload, cb) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        axios.post('/sales/getSalesOrderList', {
            ...payload
        }
        ).then(({ data }) => {
            if (data.success) {
                dispatch({ type: FETCH_SUCCESS });
                dispatch({ type: FETCH_SALES_ORDER_PROCESSING, payload: { data: data?.data || [], count: data?.count,allLabelOptions:data?.allLabelOptions || []  } })
            }
            else {
                dispatch({ type: FETCH_ERROR, payload: data.message });
                dispatch({ type: FETCH_SALES_ORDER_PROCESSING, payload: { data: [], count: 0 } })
            }

            if (cb) {
                cb(data)
            }
        }).catch(function (error) {
            const errorObj = {
                success: false,
                message: error?.message,
                status: error?.response?.status,
                code: error?.code,
                isGatewayTimeout:
                    error?.response?.status === 504 ||
                    error?.code === "ECONNABORTED" ||
                    error?.code === "ERR_NETWORK" ||
                    !error?.response,
                error,
            };
            dispatch({ type: FETCH_ERROR, payload: error.message });
            if (cb) {
                cb(errorObj)
            }
        });
    }
};

export const saveSalesOrderEntry = (payload, callback) =>
{
    return (dispatch) =>
    {
        dispatch({type: FETCH_START});
        axios.post('/sales/saveSalesOrder', payload).then(({data}) => {
            if (data.success) {
                process(data)
            } 
            else {
                //(data.message);
                dispatch({type: FETCH_ERROR, payload: data.message});
                showToast(data.message, true)
                callback(null);
            }
            function process(data) {
                dispatch({ type: FETCH_SUCCESS });
                showToast(data.message, false);
                callback(data);
            }
        }).catch(function (error) {
            dispatch({type: FETCH_ERROR, payload: error.message});
            //("Error****:", error.message);
            callback(null)
        });
    }
};

export const saveSalesOrderWithExcel = (payload, callback) =>
{
    return (dispatch) =>
    {
        dispatch({type: FETCH_START});
        axios.post('/sales/bulkSalesOrderItemUpload', payload).then(({data}) => {
            if (data.success) {
                process(data)
            } 
            else {
                //(data.message);
                dispatch({type: FETCH_ERROR, payload: data.message});
                showToast(data.message, true)
                callback(null);
            }
            function process(data) {
                dispatch({ type: FETCH_SUCCESS });
                showToast(data.message, false);
                callback(data);
            }
        }).catch(function (error) {
            dispatch({type: FETCH_ERROR, payload: error.message});
            //("Error****:", error.message);
            showToast(error.message, true);
            callback(null)
        });
    }
};


export const getSalesDetails = (payload, cb) =>
{
    return (dispatch) =>
    {
        dispatch({type: FETCH_START});
        axios.post('/sales/getSalesOrderDetail', {
            ...payload
        }
        ).then(({data}) => {
            if (data.success) 
            {
                callback(data);
            } 
            else 
            {
                dispatch({type: FETCH_ERROR, payload: data.message});
                dispatch({ type: FETCH_SALES_DETAIL, payload: {data: null, count: 0}})
                // if(payload.page || payload.limit || payload.entity_ID || payload.status || payload.submissionDate){
                //     // dispatch({ type: FETCH_ASN_DETAIL, payload: null})
                //     // Dont do anything
                // }
                // else{
                // }
                // showToast(data.message, true);
                if(cb){
                    cb()
                }
            }

            function callback(data) {
                dispatch({ type: FETCH_SUCCESS });
                dispatch({ type: FETCH_SALES_DETAIL, payload: {data: data.data, count: data.count}})
                if(cb){
                    cb(data.data)
                }
            }
        }).catch(function (error) {
            dispatch({type: FETCH_ERROR, payload: error.message});
            //("Error****:", error.message);
            showToast("Something went wrong", true);
            if(cb){
                cb()
            }
        });
    }
};

export const getSalesOrderStatusWiseCount = (payload, cb) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        axios.post('/sales/getSalesStatusWiseCount', {
            ...payload
        }
        ).then(({ data }) => {
            if (data.success) {
                dispatch({ type: FETCH_SUCCESS });
                dispatch({ type: FETCH_SALES_STATUS_COUNT, payload: data.data })
            }
            else {
                dispatch({ type: FETCH_ERROR, payload: data.message });
                dispatch({ type: FETCH_SALES_STATUS_COUNT, payload: null })
            }
            if (cb) {
                cb(data)
            }
        }).catch(function (error) {
            dispatch({ type: FETCH_ERROR, payload: error.message });
            if (cb) {
                cb({ success: false, message: error.message })
            }
        });
    }
};

export const getSalesOrderItemList = (payload, cb) =>
{
    return (dispatch) =>
    {
        dispatch({type: FETCH_START});
        axios.post('/sales/getSalesOrderItemList', {
               ...payload
        }).then(({data}) => {
            if (data.success) {
                callback();
            } 
            else {
                dispatch({type: FETCH_ERROR, payload: data.message});
                dispatch({ type: FETCH_SALES_ORDER_ITEM_LIST, payload: {rows: [], count: 0,isExtraQtyOption:{}}})
                if(cb){
                    cb();
                }
            }
            function callback() {
                dispatch({ type: FETCH_SUCCESS });
                dispatch({
                    type: FETCH_SALES_ORDER_ITEM_LIST, payload: {
                        rows: data.data, count: data.count, applyExtraValue: data.applyExtraValue
                    }
                })
                if (cb) {
                    cb(data);
                }
            }
        }).catch(function (error) {
            dispatch({type: FETCH_ERROR, payload: error.message});
            dispatch({ type: FETCH_SALES_ORDER_ITEM_LIST, payload: {rows: [], count: 0,isExtraQtyOption:{}}})
            //('here')
            //("Error****:", error.message);
            if(cb){
                cb();
            }
        });
    }
};

export const approveRejectSales = (payload, cb) =>
{
    return (dispatch) =>
    {
        dispatch({type: FETCH_START});
        axios.post('sales/changeSalesOrderStatus', {
            ...payload
        }
        ).then(({data}) => {
            if (data.success) 
            {
                callback(data);
            } 
            else 
            {
                dispatch({type: FETCH_ERROR, payload: data.message});
                showToast(data.message, true);
                if(cb){
                    cb()
                }
            }

            function callback(data) {
                dispatch({ type: FETCH_SUCCESS });
                // showToast(data.message, false);
                if(cb){
                    cb(data)
                }
            }
        }).catch(function (error) {
            dispatch({type: FETCH_ERROR, payload: error.message});
            //("Error****:", error.message);
            showToast(error.message, true);
            if(cb){
                cb()
            }
        });
    }
};

export const closeSalesOrder = (payload, cb) =>
{
    return (dispatch) =>
    {
        dispatch({type: FETCH_START});
        axios.post('/sales/closeSalesOrder', {
            ...payload
        }
        ).then(({data}) => {
            if (data.success)
            {
                callback(data);
            }
            else
            {
                dispatch({type: FETCH_ERROR, payload: data.message});
                showToast(data.message, true);
                if(cb){
                    cb()
                }
            }

            function callback(data) {
                dispatch({ type: FETCH_SUCCESS });
                if(cb){
                    cb(data)
                }
            }
        }).catch(function (error) {
            dispatch({type: FETCH_ERROR, payload: error.message});
            showToast(error.message, true);
            if(cb){
                cb()
            }
        });
    }
};

export const shareSalesOrderProcessingForm = (payload, cb) =>
{
    return (dispatch) =>
    {
        dispatch({type: FETCH_START});
        axios.post('ESO/saveESOFormConfig', {
            ...payload
        }
        ).then(({data}) => {
            if (data.success) 
            {
                callback(data);
            } 
            else 
            {
                dispatch({type: FETCH_ERROR, payload: data.message});
                showToast(data.message, true);
                if(cb){
                    cb()
                }
            }

            function callback(data) {
                dispatch({ type: FETCH_SUCCESS });
                // showToast(data.message, false);
                if(cb){
                    cb(data)
                }
            }
        }).catch(function (error) {
            dispatch({type: FETCH_ERROR, payload: error.message});
            //("Error****:", error.message);
            showToast(error.message, true);
            if(cb){
                cb()
            }
        });
    }
};

export const getEsopFormTableDataAPI = (payload, cb) =>
{
    return (dispatch) =>
    {
        dispatch({type: FETCH_START});
        axios.post('ESO/getESOFormEConfigList', {
               ...payload
        }).then(({data}) => {
            if (data.success) {
                dispatch({ type: FETCH_SUCCESS });
                dispatch({ type: FETCH_ESOPFORM_TABLE_DATA, payload: {data: data.data, count: data.count}})
            } 
            else {
                dispatch({type: FETCH_ERROR, payload: data.message});
                dispatch({ type: FETCH_ESOPFORM_TABLE_DATA, payload: {data: [], count: 0}})
            }
            if(cb){
                cb(data);
            }
        }).catch(function (error) {
            dispatch({type: FETCH_ERROR, payload: error.message});
            //('here')
            //("Error****:", error.message);
            if(cb){
                cb();
            }
        });
    }
};
export const getPassLinkValidationToken = (payload, cb) =>
{
    return (dispatch) =>
    {
        dispatch({type: FETCH_START});
        axios.post('ESO/passcodeValidation', {
               ...payload
        }).then(({data}) => {
            if (data.success) {
                dispatch({ type: FETCH_SUCCESS });
                dispatch({ type: FETCH_PASSLINK_VALIDATION_TOKEN, payload: data?.data ||""})
            } 
            else {
                dispatch({type: FETCH_ERROR, payload: data.message});
                dispatch({ type: FETCH_PASSLINK_VALIDATION_TOKEN, payload:  ""})
            }
            if(cb){
                cb(data);
            }
        }).catch(function (error) {
            dispatch({type: FETCH_ERROR, payload: error.message});
            //('here')
            //("Error****:", error.message);
            if(cb){
                cb();
            }
        });
    }
};


export const getAssociatedJobDetails = (payload, cb) =>
{
    return (dispatch) =>
    {
        dispatch({type: FETCH_START});
        axios.post('/job/getAssociatedJobDetails', {
            ...payload
        }
        ).then(({data}) => {
            if (data.success) 
            {
                callback(data);
            } 
            else 
            {
                dispatch({type: FETCH_ERROR, payload: data.message});
                dispatch({ type: FETCH_ASSOCIATED_JOB, payload: {data: null, count: 0}})
                // if(payload.page || payload.limit || payload.entity_ID || payload.status || payload.submissionDate){
                //     // dispatch({ type: FETCH_ASN_DETAIL, payload: null})
                //     // Dont do anything
                // }
                // else{
                // }
                // showToast(data.message, true);
                if(cb){
                    cb(data)
                }
            }

            function callback(data) {
                dispatch({ type: FETCH_SUCCESS });
                dispatch({ type: FETCH_ASSOCIATED_JOB, payload: {data: data.data, count: data.count}})
                if(cb){
                    cb(data)
                }
            }
        }).catch(function (error) {
            dispatch({type: FETCH_ERROR, payload: error.message});
            //("Error****:", error.message);
            showToast("Something went wrong", true);
            if(cb){
                cb()
            }
        });
    }
};


export const getAssociatedTripDetails = (payload, cb) =>
{
    return (dispatch) =>
    {
        dispatch({type: FETCH_START});
        axios.post('/sales/getTripDetails', {
            ...payload
        }
        ).then(({data}) => {
            if (data.success) 
            {
                callback(data);
            } 
            else 
            {
                dispatch({type: FETCH_ERROR, payload: data.message});
                dispatch({ type: FETCH_ASSOCIATED_TRIP, payload: {data: null, count: 0}})
                // if(payload.page || payload.limit || payload.entity_ID || payload.status || payload.submissionDate){
                //     // dispatch({ type: FETCH_ASN_DETAIL, payload: null})
                //     // Dont do anything
                // }
                // else{
                // }
                // showToast(data.message, true);
                if(cb){
                    cb(data)
                }
            }

            function callback(data) {
                dispatch({ type: FETCH_SUCCESS });
                dispatch({ type: FETCH_ASSOCIATED_TRIP, payload: {data: data.data, count: data.count}})
                if(cb){
                    cb(data)
                }
            }
        }).catch(function (error) {
            dispatch({type: FETCH_ERROR, payload: error.message});
            //("Error****:", error.message);
            showToast("Something went wrong", true);
            if(cb){
                cb()
            }
        });
    }
};


export const getAvailableSlots = (payload,callBack) =>{
        return (dispatch) =>
        {
            axios.interceptors.request.use(function (config) {
                // console.log("parse", parsedExternalRout)
                if (payload?.isExternalRoute) {
                    config["headers"]["partialaccesstoken"] = window.localStorage.getItem("passToken") && JSON.parse(window.localStorage.getItem("passToken")) || ""
                    config["headers"]["Authorization"]=""
                }
                return config;
            }, function (error) {
                // Do something with request error
                return Promise.reject(error);
            });
            dispatch({type: FETCH_START});
            axios.post('/base/getAllSlotsList', {
                   ...payload
            }).then(({data}) => {
                if (data.success) {
                    dispatch({ type: FETCH_SUCCESS });
                    dispatch({ type: FETCH_AVAILABLE_SLOTS, payload: data.data})
                 
                } 
                else {
                    dispatch({type: FETCH_ERROR, payload: data.message});
                    dispatch({ type: FETCH_AVAILABLE_SLOTS, payload: []})
                }
                if(callBack){
                    callBack(data)
                }
            }).catch(function (error) {
                dispatch({ type: FETCH_AVAILABLE_SLOTS, payload: []})
                dispatch({type: FETCH_ERROR, payload: error.message});
                if(callBack){
                    callBack({success:false,message:error.message})
                }
                //("Error****:", error.message);
            });
        }
    };

    export const saveMultipleSOBulkUpload = (payload, callback) => {
        return (dispatch) => {
            dispatch({ type: FETCH_START });
            axios.post('/sales/saveMultiSalesOrder', payload).then(({ data }) => {
                if (data.success) {
                    process(data)
                }
                else {
                    //(data.message);
                    dispatch({ type: FETCH_ERROR, payload: data.message });
                    showToast(data.message, true)
                    callback(null);
                }
                function process(data) {
                    dispatch({ type: FETCH_SUCCESS });
                    showToast(data.message, false);
                    callback(data);
                }
            }).catch(function (error) {
                dispatch({ type: FETCH_ERROR, payload: error.message });
                //("Error****:", error.message);
                showToast(error.message, true);
                callback(null)
            });
        }
    };

    export const getSalesOrderCardWiseCount = (payload, cb) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        axios.post('/sales/getSalesOrderCardWiseCount', {
            ...payload
        }
        ).then(({ data }) => {
            if (data.success) {
                dispatch({ type: FETCH_SUCCESS });
                dispatch({ type: FETCH_SALES_ORDER_CARD_COUNT, payload: data.data })
            }
            else {
                dispatch({ type: FETCH_ERROR, payload: data.message });
                dispatch({ type: FETCH_SALES_ORDER_CARD_COUNT, payload: null })
            }
            if (cb) {
                cb(data)
            }
        }).catch(function (error) {
            dispatch({ type: FETCH_ERROR, payload: error.message });
            if (cb) {
                cb({ success: false, message: error.message })
            }
        });
    }
};

    export const validateSalesStockConsumption = (payload, cb) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        axios.post('/sales/validateSalesStockConsumption', {
            ...payload
        }
        ).then(({ data }) => {
            if (data.success) {
                dispatch({ type: FETCH_SUCCESS });
                dispatch({ type: VALIDATE_SALES_CONSUMPTION, payload: data.data })
            }
            else {
                dispatch({ type: FETCH_ERROR, payload: data.message });
                dispatch({ type: VALIDATE_SALES_CONSUMPTION, payload: [] })
            }
            if (cb) {
                cb(data)
            }
        }).catch(function (error) {
            dispatch({ type: FETCH_ERROR, payload: error.message });
            if (cb) {
                cb({ success: false, message: error.message })
            }
        });
    }
};


export const getSOWiseDispatchPlansData = (payload, cb) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        axios.post('/job/getSOWiseDispatchPlan', {
            ...payload
        }
        ).then(({ data }) => {
            if (data.success) {
                dispatch({ type: FETCH_SUCCESS });
                dispatch({ type:  FETCH_SALES_ORDER_DISPATCH_PLANS, payload: { data: data?.data || [], count: data?.count  } })
            }
            else {
                dispatch({ type: FETCH_ERROR, payload: data.message });
                dispatch({ type: FETCH_SALES_ORDER_DISPATCH_PLANS, payload: { data: [], count: 0 } })
            }

            if (cb) {
                cb(data)
            }
        }).catch(function (error) {
            dispatch({ type: FETCH_ERROR, payload: error.message });
            if (cb) {
                cb({ success: false, message: error.message })
            }
        });
    }
};

export const saveDispatchPlanUpload = (payload, callback) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        axios.post('sales/createDispatchPlan', payload).then(({ data }) => {
            if (data.success) {
                process(data)
            }
            else {
                //(data.message);
                dispatch({ type: FETCH_ERROR, payload: data.message });
                showToast(data.message, true)
                callback(null);
            }
            function process(data) {
                dispatch({ type: FETCH_SUCCESS });
                showToast(data.message, false);
                callback(data);
            }
        }).catch(function (error) {
            dispatch({ type: FETCH_ERROR, payload: error.message });
            //("Error****:", error.message);
            showToast(error.message, true);
            callback(null)
        });
    }
};